export default "__VITE_ASSET__CkR0xI7a__"